"use client";

import { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuContext from '@/context/MenuProvider';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import axios from 'axios';
import TokenContext from '@/context/TokenProvider';
import MessageContext from '@/context/MessageProvider';

const KritikSaranDialog = (props) => {
  const { accessToken } = useContext(TokenContext)!;
  const { message, setMessage } = useContext(MessageContext)!;
  const [kategori, setKategori] = useState('');
  const [konten, setKonten] = useState('');
  const { stateKritikSaranDialog, setStateKritikSaranDialog } = useContext(MenuContext)!;

  const handleClose = () => {
    setStateKritikSaranDialog(false);
  };

  const handleChange = (event) => {
    setKategori(event.target.value);
  };

  const sendKritikSaran = async () => {
    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/v2/saran`,
        {
          kategori: kategori,
          konten: konten
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
      setMessage({ isOpen: true, content: response.data.message });
    } catch (error) {
      console.error(error.response);
    }
  };

  const handleSendData = () => {
    sendKritikSaran();
    setStateKritikSaranDialog(false);
  };

  return (
    <Dialog open={stateKritikSaranDialog} onClose={handleClose}>
      <DialogTitle
        sx={{ fontWeight: 'bold', fontSize: '16px', textAlign: 'center' }}
      >
        Form Kritik dan Saran
      </DialogTitle>
      <DialogContent sx={{ width: '328px' }}>
        <FormControl fullWidth size="small">
          <Typography sx={{ fontSize: '12px' }}>Kategori</Typography>
          <Select
            value={kategori}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
          >
            <MenuItem value={'1'}>Fasilitas</MenuItem>
            <MenuItem value={'2'}>Buku</MenuItem>
            <MenuItem value={'3'}>Pelayanan</MenuItem>
            <MenuItem value={'4'}>Sistem/Aplikasi</MenuItem>
            <MenuItem value={'5'}>Lainnya</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth size="small" sx={{ marginTop: '22px' }}>
          <Typography sx={{ fontSize: '12px' }}>Kritik dan Saran</Typography>
          <TextField
            multiline
            rows={4}
            value={konten}
            onChange={(e) => {
              setKonten(e.currentTarget.value);
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ width: 'fit-content', margin: 'auto' }}>
        <Button variant="contained" onClick={handleSendData}>
          Kirim
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KritikSaranDialog;
